import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetAdminSolar_connectionsCatalog = z.any()
export type TagsGetAdminSolar_connectionsCatalog = z.infer<typeof tagsGetAdminSolar_connectionsCatalog>

export const paramsGetAdminSolar_connectionsCatalog = z.object({})
export type ParamsGetAdminSolar_connectionsCatalog = z.infer<typeof paramsGetAdminSolar_connectionsCatalog>

export const responseGetAdminSolar_connectionsCatalog = z.object({ "payload": z.object({ "providers": z.array(z.object({ "id": z.union([z.literal("dzd"), z.literal("solax")]), "name": z.string(), "category": z.literal("solar"), "endpoint": z.string(), "intervalSeconds": z.number() })), "metrics": z.array(z.object({ "key": z.string(), "label": z.string(), "unit": z.string() })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetAdminSolar_connectionsCatalog = z.infer<typeof responseGetAdminSolar_connectionsCatalog>

interface IGetAdminSolar_connectionsCatalog extends BaseMethodType {
  tags: TagsGetAdminSolar_connectionsCatalog,
  params: ParamsGetAdminSolar_connectionsCatalog,
  response: ResponseGetAdminSolar_connectionsCatalog
}
export const URL = '/admin/solar-connections/catalog'
export const validation = {
  get: {
    tags: tagsGetAdminSolar_connectionsCatalog,
    params: paramsGetAdminSolar_connectionsCatalog,
    response: responseGetAdminSolar_connectionsCatalog
  }
}
export interface AdminSolar_connectionsCatalog extends BaseRouteType {
  get: IGetAdminSolar_connectionsCatalog
}